import SinglePageModalViewer from 'components/Workbook/SinglePageModalViewer';
import React from 'react';
import { WorkbookState } from 'types';

type Props = {
  workbook: WorkbookState;
  currentPage: number;
  width: number;
};

const WorkbookPageModal = ({ workbook, currentPage, width }: Props) => {
  return <SinglePageModalViewer currentPage={currentPage} workbook={workbook} width={width} />;
};
export default WorkbookPageModal;
